<style scoped>
  .information >>> .ivu-anchor-ink{height: 100%;right: 72px;top: 0;left: auto;}
  .information >>> .ivu-anchor-link{padding: 23px 0 0px 16px;}
  .line{margin-bottom:25px}
  .information >>> .ivu-anchor-ink-ball{width: 17px;height: 17px;border-radius: 50%;background-color: #00a2e9;left: 50%;border: 3px solid #fff;}
  .information >>> .ivu-select{width: 440px;}
  .information >>> .ivu-input-suffix{top: 4px;}
  .navigation >>> .ivu-input-icon{top: 3px;}
  .information >>> .ivu-switch-checked {border-color: #45db5e;background-color: #45db5e;}
  .inputTips{display: inline-block;margin-right: 24px;font-size: 14px;color: #657180;text-align: right;vertical-align: top;margin-top: 8px;width:100px;}
</style>

<template>
  <div class="information">
    <div style="padding:5px"></div>
    <!--项目标题-->
    <div style="margin: 25px 0">
      <p class="inputTips">项目名称</p>
      <Input v-model="content.name"  style="width: 440px" placeholder="填写项目名称"/>
    </div>
    <!--案号-->
    <div style="margin: 25px 0">
      <p class="inputTips" style="margin-top: 0;">案号</p>
      <Input v-model="content.caseNumber"  style="width: 440px" placeholder="修改案号"/>
    </div>
    <!--收案日期-->
    <div style="margin: 25px 0">
      <p class="inputTips">收案日期</p>
      <DatePicker v-model="content.createDate"  type="date" format="yyyy-MM-dd" placeholder="请输入收案日期"></DatePicker>
    </div>
    <!--争议标的额-->
    <div style="margin: 25px 0">
      <p class="inputTips">争议标的额</p>
      <Input v-model="content.caseAmount"  style="width: 440px" placeholder="填写争议标的额"/>
    </div>
    <!--收费金额-->
    <div style="margin: 25px 0">
      <p class="inputTips">收费金额</p>
      <Input v-model="content.projectAmount"  style="width: 140px" placeholder="填写收费金额"/>万元
    </div>
    <!--收费方式 payTypeList-->
    <!--<div style="margin: 25px 0;">-->
      <!--<p class="inputTips">收费方式</p>-->
      <!--<Select style="width:200px" v-model="content.payType" filterable placeholder="选择收费方式">-->
        <!--<Option v-for="(item,index) in payTypeList" :value="item.id" :key="index.toString()">{{ item.name }}</Option>-->
      <!--</Select>-->
    <!--</div>-->
    <!--案件阶段-->
    <div style="margin: 25px 0">
      <p class="inputTips">案件阶段</p>
      <Input v-model="content.caseStage"  style="width: 440px" placeholder="填写争案件阶段"/>
    </div>
    <!--受理机关-->
    <div style="margin: 25px 0">
      <p class="inputTips">受理机关</p>
      <Input v-model="content.receivingUnitText"  style="width: 440px" placeholder="填写争受理机关"/>
    </div>
    <!--受理机关-->
    <!--<div style="margin: 25px 0;">-->
      <!--<p class="inputTips">受理机关</p>-->
      <!--<Select style="width:200px" v-model="content.receivingUnit" filterable placeholder="选择受理机关">-->
        <!--<Option v-for="(item,index) in receivingUnitList" :value="item.id" :key="index.toString()">{{ item.name }}</Option>-->
      <!--</Select>-->
    <!--</div>-->
    <!--简要案情-->
    <div style="margin: 25px 0">
      <p class="inputTips">简要案情</p>
      <Input type="textarea" :autosize="{minRows: 5, maxRows: 13}" v-model="content.caseDetails"  style="width: 440px;vertical-align:top;" placeholder="填写简要案情"/>
    </div>
    <div style="border-top: 1px solid #d7dde4">
      <Row :gutter="20" type="flex" justify="center" style="margin-top: 40px;">
        <Col span="4">
          <Button type="primary" style="width:100%;" @click="saveProjectRegister()" v-if="$route.query.filed!=1">保存信息</Button>
        </Col>
      </Row>
    </div>
    <div style="padding: 10px;"></div>
  </div>
</template>

<script>
  export default {
    name: "situation",//案情
    data() {
      return {
        content:{
          name:'',
          caseAmount:'',
          projectAmount:'',
          caseStage:'',
          caseDetails:'',
          createDate:'',
          caseNumber:'',
          payType:'',
          receivingUnit:'',
          receivingUnitText:'',
        },
        litigation:[],
        identity:[],
        projectTypeList:[],
        causeTypeList:[],
        modelTypeList : [],
        modelList : [],
        userList:[],
        sourceSelectedList:[],
        managerSelectedList:[],
        otherUserSelectedList:[],
        payTypeList:[],
        receivingUnitList:[],
        tempContent:{},
      }
    },
    methods: {
      //获取收费方式
      getPayType:function(){
        var _this = this
        _this.payTypeList = []
        _this.send({
          headers:'C/CaseChargeList',
          success:function (res) {
            for(var index in res){
              _this.payTypeList.push({
                id:res[index].CaseChargeId,
                name:res[index].CaseChargeTitle,
              })
            }
          }
        })
      },
      //获取受理机关
      receivingUnit:function(){
        var _this = this
        _this.receivingUnitList = []
        _this.send({
          headers:'C/CaseAcceptanceList',
          success:function (res) {
            for(var index in res){
              _this.receivingUnitList.push({
                id:res[index].CaseAcceptanceId,
                name:res[index].CaseAcceptanceName,
              })
            }
          }
        })
      },
      //保存信息
      saveProjectRegister:function () {
        var _this = this
        var date = new Date(_this.content.createDate)
        var dateTemp = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
        _this.send({
          headers:'C/CaseAdd',
          data:{
            CaseCreateTime:dateTemp,//收案日期
            CaseTitle:_this.content.name,//项目标题
            CaseSubjectMatter:_this.content.caseAmount,//争议标的额
            CasePayCount:_this.content.projectAmount,//收费金额
            CasePayWay:_this.content.payType,//结算方式ID
            CaseChargeId:_this.content.payType||'',//结算方式ID
            CaseStage:_this.content.caseStage,//案件阶段
            CaseAcceptanceId:_this.content.receivingUnit,//案件受理机关ID -- */*
            CaseAcceptanceText:_this.content.receivingUnitText,//案件受理机关ID -- */*
            CaseSituation:_this.content.caseDetails,//简要案情
            CaseId:_this.$route.query.caseId,
            //
            CaseSource:_this.tempContent.case_source_id,
            CaseActionInfo:_this.tempContent.case_action_info,
            CaseLinkman:_this.tempContent.case_linkman,
            CaseLinkmanTel:_this.tempContent.case_linkman_tel,
            CaseConflictId:_this.tempContent.case_conflict_id,
            CaseTypeId:_this.tempContent.case_type_id,
            CaseClassId:'',
            CaseNum:_this.content.caseNumber,
          },
          success:function () {
            _this.projectRegister()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改成功！',
            })
          }
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.tempContent = res
            var content = {
              name:res.case_title,
              caseNumber:res.case_num,
              caseAmount:res.case_subject_matter,
              projectAmount:res.case_pay_count,
              caseStage:res.case_stage,
              caseDetails:res.case_situation,
              createDate:res.case_create_time,
              payType:parseInt(res.case_charge_id),
              receivingUnit:parseInt(res.case_acceptance_id),
              receivingUnitText:res.case_acceptance_text,
            }
            _this.content = content
          }
        })
      },
    },
    mounted: function () {
      this.getPayType()
      // this.receivingUnit()
      this.projectRegister()
    },
  }
</script>


